module.exports = __webpack_public_path__ + "static/img/3432_phase_function_Paper_PointsHejduk_Prediction.549fb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3432_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kn/b
// module chunks = 0